<template>
  <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
    <v-btn icon @click="show = !show" color="teal darken-2" slot="activator">
      <v-icon color="white">{{ show ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
    </v-btn>
    <v-card>
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="dialog = show = false">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>Details</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-list three-line subheader>
        <v-container class="mt-3">
          <v-layout row wrap>
            <v-flex xs12 sm12 md3>
              <v-img>Image will be addedd later</v-img>
              <!-- <v-img v-bind:src="project.image_url" height="300px" contain></v-img> -->
            </v-flex>

            <v-flex xs12 sm12 md9 class="px-3">
              <h1>{{ stock.item.stock }}</h1>
              <h4>Point : {{ stock.item.report_three.total }}</h4>
              <h4>Quartal : {{stock.item.quartal}}</h4>
              <h4>Sector : {{stock.item.sector}}</h4>
              <h4>Last Update : {{new Date(stock.item.report_three.updated_at).getFullYear()}}-{{new Date(stock.item.report_three.updated_at).getMonth()+1}}-{{new Date(stock.item.report_three.updated_at).getDate()}}</h4>
              <p class="mt-2 white-space-pre">The result of scanned each Stock divided to be 4 type of report. Report 1 and Report 2 based on comparing this year and last one year ago in same quartal. Well, in report 1 and report 2, will get point. More bigger point, more better the financial report.</p>
              <p class="mt-2 white-space-pre">After found the biggest point, next to seeking the cheap Stock. Indicator the Stock cheap or not, we can looking in Report 3. Usually, in general indicator of stock cheap or not besed on PER and PBV. And in Report 4, to provide the last report of financial Report in this year in general.</p>
              <p class="mt-2 white-space-pre">Check again the original financial report directly after read this recap of result of scanning financial report. It will make sure your decision in the right way.</p>
            </v-flex>
          </v-layout>
        </v-container>
      </v-list>
      <v-divider></v-divider>
      <v-list three-line subheader>
        <v-container>
          <v-layout row wrap>
            <v-flex xs12 sm6 md3 class="px-2">
              <h2>Report 1: </h2>
              <p>Assets (%) : {{stock.item.assets}}</p>
              <p>Current Assets (%) : {{stock.item.current_assets}}</p>
              <p>Liabilities (%) : {{stock.item.liabilities}}</p>
              <p>Current Liabilities (%) : {{stock.item.current_liabilities}}</p>
              <p>Equity (%) : {{stock.item.equity}}</p>
              <p>Earnings (%) : {{stock.item.earnings}}</p>
              <p>Share Capital (%) : {{stock.item.share_capital}}</p>
              <p>Sales (%) : {{stock.item.sales}}</p>
              <p>Operating Income (%) : {{stock.item.operating_income}}</p>
              <p>Net Income (%) : {{stock.item.net_income}}</p>
              <p>Eps (%) : {{stock.item.eps}}</p>
              <p>Total in Report 1 (X) : {{stock.item.total}}</p>
            </v-flex>
            <v-flex xs12 sm6 md3 class="px-2">
              <h2>Report 2: </h2>
              <p>EDR (%) : {{stock.item.report_two.edr}}</p>
              <p>EER (%) : {{stock.item.report_two.eer}}</p>
              <p>EAR (%) : {{stock.item.report_two.ear}}</p>
              <p>ROA (%) : {{stock.item.report_two.roa}}</p>
              <p>ROE (%) : {{stock.item.report_two.roe}}</p>
              <p>OPM (%) : {{stock.item.report_two.opm}}</p>
              <p>NPM (%) : {{stock.item.report_two.npm}}</p>
              <p>Total in Report 2 (X) : {{stock.item.total}}</p>
            </v-flex>
            <v-flex xs12 sm6 md3 class="px-2">
              <h2>Report 3: </h2>
              <p>Current Price (Rp) : {{stock.item.report_three.current_price}}</p>
              <p>Market Capital (Rp) : {{stock.item.report_three.mkt_cap}}</p>
              <p>Market Capital Assets (X) : {{stock.item.report_three.mkt_cap_assets}}</p>
              <p>PER (X) : {{stock.item.report_three.per}}</p>
              <p>PBV (X) : {{stock.item.report_three.pbv}}</p>
            </v-flex>
            <v-flex xs12 sm6 md3 class="px-2">
              <h2>Report 4: </h2>
              <p>Assets (Rp) : {{stock.item.report.assets}}</p>
              <p>Current Assets (Rp) : {{stock.item.report.current_assets}}</p>
              <p>Liabilities (Rp) : {{stock.item.report.liabilities}}</p>
              <p>Current Liabilities (Rp) : {{stock.item.report.current_liabilities}}</p>
              <p>Equity (Rp) : {{stock.item.report.equity}}</p>
              <p>Earnings (Rp) : {{stock.item.report.earnings}}</p>
              <!-- <p>Share Capital (Rp) : {{stock.item.report.share_capital}}</p> -->
              <p>Sales (Rp) : {{stock.item.report.sales}}</p>
              <p>Operating Income (Rp) : {{stock.item.report.operating_income}}</p>
              <p>Net Income (Rp) : {{stock.item.report.net_income}}</p>
              <p>Eps (Rp) : {{stock.item.report.eps}}</p>
            </v-flex>
          </v-layout>
        </v-container>
      </v-list>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    stock: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      show: false,
      dialog: false
    };
  }
  // mounted() {
  //     console.log(this.stock)
  // }
};
</script>

